import { render, staticRenderFns } from "./base-input-text-growing.vue?vue&type=template&id=357c5f5e&"
import script from "./base-input-text-growing.vue?vue&type=script&lang=ts&"
export * from "./base-input-text-growing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports